// Seeded randomness for world generation.
//
// Every world was drawn from Math.random, so no two runs could be compared and no map could ever be
// looked at twice. That made the generator impossible to tune — a change to the router or the
// terrain thresholds moved the numbers, but so did doing nothing — and it is one of the two reasons
// the e2e specs are flaky over generated content.
//
// Scope is deliberately narrow: this seeds *map generation* only. The rest of the game — combat
// rolls, event weighting, ambient prose — keeps Math.random, because a run the player can replay
// exactly is a different game, not a fixed bug.

// mulberry32. One 32-bit word of state, so seeding is a single hash, and far better distributed
// than terrain noise needs.
function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// djb2, the same hash lib/strings/city.js already uses to pick deterministically from a list.
function hashSeed(value) {
  let hash = 5381;
  const str = String(value);
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return Math.abs(hash) | 0;
}

let current = Math.random;

// Null or undefined restores Math.random, which is the unseeded default and the app's normal state.
function setSeed(seed) {
  current = seed == null || seed === "" ? Math.random : mulberry32(hashSeed(seed));
}

function random() {
  return current();
}

export { random, setSeed };
